<div class="flex items-center justify-between mb-1">
  <span class="font-semibold">Utilization by time of week</span>
  @if (estimated()) {
    <mat-icon
      class="cursor-help text-base text-ui-gray-dark"
      [attr.aria-label]="estimatedTooltip"
      [matTooltip]="estimatedTooltip"
      fontIcon="info"
    />
  }
</div>

<p class="text-xs text-ui-gray-dark mb-2">Max value: {{ maxValue() | number: '1.0-0' }}</p>

<highcharts-chart
  class="block"
  [options]="chartOptions()"
/>
